export default {
  image: [".jpg", ".jpeg", ".gif", ".png", ".apng", ".webp", ".bmp", ".ico"],
  video: [".mp4", ".webm", ".mov", ".ogv", ".ogg", ".ogx"],
  audio: [".mp3", ".wav", ".ogg"],
  document: [".pdf", ".docx", ".doc", ".odt", ".odf"],
  pdf: [".pdf"],
};
